import { useCallback, useContext } from 'react';
import { FrameworkSimpleHeader } from '../..';
import FrameworkContext from '../framework/FrameworkContext';

function useFramework() {
  const {state, dispatch} = useContext(FrameworkContext);
  const { defaultSetting } = state;
  const {
    frameworkDefaultHeader, frameworkDefaultFooter, frameworkDefaultSiderBar,
    frameworkDefaultVisibleCity, frameworkDefaultVisibleFooter, frameworkDefaultVisibleHeader,
    frameworkDefaultVisibleSiderBar, frameworkDefaultSimpleHeader
  } = defaultSetting;

  const setDefaultSetting = useCallback((values) => {
    dispatch({
      payload: {
        ...state,
        defaultSetting: {
          ...values
        }
      }
    })
  }, [state, dispatch]);

  const initFramework = useCallback(() => {
    dispatch({
      payload: {
        ...state,
        header: frameworkDefaultHeader || null,
        visibleHeader: frameworkDefaultVisibleHeader,
        siderBar: frameworkDefaultSiderBar || null,
        visibleSiderBar: frameworkDefaultVisibleSiderBar,
        footer: frameworkDefaultFooter || null,
        visibleFooter: frameworkDefaultVisibleFooter,
        visibleCity: frameworkDefaultVisibleCity,
        visibleSimpleHeader: frameworkDefaultSimpleHeader,
        className: '',
        headerClassName: '',
        quickMenu: null,
      }
    })
  }, [state, dispatch, frameworkDefaultHeader, frameworkDefaultVisibleHeader,
    frameworkDefaultSiderBar, frameworkDefaultVisibleSiderBar, frameworkDefaultFooter,
    frameworkDefaultVisibleFooter, frameworkDefaultVisibleCity
  ]);

  return {
    state,
    actions: {
      setDefaultSetting,
      initFramework,
      dispatch
    }
  }
}

export default useFramework
